/**
 * Web sources section component for citations
 */

import { useTranslation } from "react-i18next"

import type { CategorizedCitation } from "../../utils/citation-categorizer"

import { Globe } from "@/components/icons"

import { UrlCitationItem } from "../url-citation-item"

type WebSourcesSectionProps = {
  sources: CategorizedCitation[]
  onShowChunk: (citation: string) => void
  hasChunkData: (citation: string) => boolean
  onNavigateToInline: (index: number) => void
  highlightedIndex: number | null
  messageIndex?: number
}

export function WebSourcesSection({
  sources,
  onShowChunk,
  hasChunkData,
  onNavigateToInline,
  highlightedIndex,
  messageIndex,
}: WebSourcesSectionProps) {
  const { t } = useTranslation()

  if (sources.length === 0) return null

  return (
    <div className="space-y-2">
      <h4 className="text-muted-foreground flex items-center gap-2 text-sm font-semibold">
        <Globe className="size-4" />
        <span>
          {t("answer.web_sources")} ({sources.length})
        </span>
      </h4>
      <div className="grid grid-cols-1 gap-2">
        {sources.map(({ citation, index }) => (
          <UrlCitationItem
            key={index}
            citation={citation}
            hasChunk={hasChunkData(citation)}
            index={index}
            isHighlighted={highlightedIndex === index}
            messageIndex={messageIndex}
            onNavigateToInline={onNavigateToInline}
            onShowChunk={onShowChunk}
          />
        ))}
      </div>
    </div>
  )
}
